export class ApplyRequest {
    public referralCode: string = '';
    public companyCode: string = '';
    public jobPostingId: number = 0;
    public resumeGUID!: string;
    public utmTrackerId!: number;
    public sourceChannel: string = 'Talent Portal';
}

// tslint:disable-next-line: max-classes-per-file
export class ApplyRequestWrapper {
    public accessToken: string = '';
    public applyRequest: ApplyRequest = new ApplyRequest();
}

// tslint:disable-next-line: max-classes-per-file
export class Apply {
    public success?: any;
    public successMessage?: any;
    public errorCode: string = '';
    public errorMessage: string = '';
    public pageNumber?: any;
    public pageSize?: any;
    public resultSize?: any;
    public companyCode: string = '';
    public companyName?: any;
    public companyLogo?: any;
    public remainingJobPostitons?: any;
    public nextPage: string = '';
}
